var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',{staticClass:"expanded-data-table"},[_c('td',{attrs:{"colspan":"100%"}},[_c('v-row',{attrs:{"no-gutters":"","align":"center","justify":"space-around"}},_vm._l((_vm.items),function({key, title, icon, content}){return _c('expanded-item',{key:key,attrs:{"title":title,"icon":icon,"content":content}})}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }